import { Button } from "@mui/material";
import { IKeyDriveButton } from "../Fonts/Types/IKeyDriveButton";

export function KeyDriveSecondaryButton({
    startIcon,
    onClick,
    height,
    width,
    needFullWidth,
    disabled,
    TextComponent,
    TextComponentProps: {
        color,
        needBold,
        needEllipses,
        text
    }
}: IKeyDriveButton) {
    return (
        <Button
            variant="outlined"
            startIcon={startIcon}
            onClick={onClick}
            sx={{
                width: width,
                height: height,
                background: "white",
                color: "#22638D",
                ":hover": {
                    background: "#D3E0E8",
                    color: "#22638D"
                },
                ":disabled": {
                    background: "#D5D5D5",
                    color: "#969696"
                }
            }}
            fullWidth={needFullWidth}
            disabled={disabled}
        >
            <TextComponent
                color={color}
                needBold={needBold}
                needEllipses={needEllipses}
                text={text}
            />
        </Button>
    )
}
